import { createStore } from 'effector'
import { Thread } from '@loctypes'
import { fetchThreadsFx } from './effects'
import { mapDefaultThread, mapThreads } from './helpers'

const $rawThreads = createStore<Thread[]>([]).on(fetchThreadsFx.doneData, (_, data) => data)

export const $threads = mapThreads($rawThreads)
export const $defaultThread = mapDefaultThread($rawThreads, $threads)
